// import config from './config';

const fontFace = 'Univers, Helvetica, Arial, Sans-Serif';
const baseFontSize = 12;

export default function getNodeConfig(name, level) {
    if (level === 0) {
        return {
            id: Math.random(),
            shape: 'circle',
            margin: 20,
            label: name,
            font: {
                color: '#fff',
                size: baseFontSize,
                face: fontFace,
            },
            color: {
                border: '#fff',
                background: '#000000',
                highlight: {
                    background: '#000000',
                    border: '#fff',
                },
            },
            borderWidth: 3,
            // does not work, see https://github.com/almende/vis/issues/2762
            borderWidthSelected: 3,
        };
    }

    // Level 1
    if (level === 1) {
        return {
            id: Math.random(),
            label: name,
            shape: 'box',
            margin: 10,
            shapeProperties: {
                borderRadius: 80,
            },
            font: {
                color: '#000',
                size: baseFontSize,
                face: fontFace,
                bold: '',
            },
            borderWidth: 2,
            color: {
                border: '#fff',
                background: '#fff',
                highlight: {
                    border: '#fff',
                    background: '#fff',
                },
            },
        };
    }

    return {
        id: Math.random(),
        borderWidth: 1,
        label: name,
        shape: 'dot',
        font: {
            color: '#fff',
            size: baseFontSize,
            align: 'center',
            face: fontFace,
        },
        size: 5,
        color: {
            border: 'rgba(0, 0, 0, 0)',
            background: '#fff',
            highlight: '#fff',
        },
    };

}
